import React, { useEffect } from "react";
import Button from '@material-ui/core/Button';
import Dropdown from "./dropdown.components";
import PreviewResults from "./previewResults.component"
import useNewReportStyles from "./newReport.style";
import { ReportContext } from "../../layout/Content/MainContent.component";
import axios from 'axios';
import { get_period, get_networks, get_content_types, get_years, get_weeks, get_preview } from "../../config/apiUrls"




function NewReportPrompt(props) {

    const {
        activeTab,
        handleNext,
        networks,
        setNetworks,
        contentTypes,
        setContentTypes,
        year,
        setYear,
        week,
        setWeek,
        setPeriod,
        setSpec,
        setTemp,
        setSelectedMediums,
        setSimulateData,
        setSelectedMetrics
    } = React.useContext(ReportContext);

    const classes = useNewReportStyles();
    const [showPreview, setShowPreview] = React.useState(true);
    const [networksList, setNetworksList] = React.useState([]);
    const [contentTypesList, setContentTypesList] = React.useState([]);
    const [yearsList, setYearsList] = React.useState([]);
    const [weeksList, setWeeksList] = React.useState([]);
    const [previewData, setPreviewData] = React.useState(null)
    const options = [
        {
            label: "Network",
            getLabel: networksList,
            items: [],
            multiSelect: true,
            labelKey: "networkDisplayName",
        },
        {
            label: "Content Type",
            getLabel: contentTypesList,
            items: [],
            multiSelect: true,
            labelKey: "contentTypeDisplayName"
        },
        {
            label: "Year",
            getLabel: yearsList,
            items: [],
            multiSelect: false,
            labelKey: "year"
        },
        {
            label: "Week",
            getLabel: weeksList,
            items: [],
            multiSelect: false,
            labelKey: "weekId"
        }
    ]
    useEffect(() => {
        if (year && week) {
            axios.get(`${get_period}/${year.year}/${week.weekId}`)
                .then((response) => {
                    setPeriod(response.data);
                }).catch((e) => {
                    console.log('fetch failed');

                });
        }
    }, [year, week])

    useEffect(() => {
        if (year) {
            axios.get(`${get_weeks}/${year.year}`)
                .then((response) => {
                    setWeeksList(response.data);
                }).catch((e) => {
                    console.log('fetch failed');
                });
        }
    }, [year])


    useEffect(() => {
        const getNetworks = axios.get(get_networks);
        const getContentTypes = axios.get(get_content_types);
        const getYears = axios.get(get_years);
        axios.all([getNetworks, getContentTypes, getYears]).then(axios.spread((...responses) => {
            setNetworksList(responses[0].data);
            setContentTypesList(responses[1].data);
            setYearsList(responses[2].data);
            // setLoading(false);
        })).catch(error => {
            console.log(error);
            // setLoading(false);
        })
    }, [])

    const generatePreview = _ => {
        if (year && week)
            axios.get(`${get_preview}/${year.year}/${week.weekId}`)
                .then((response) => {
                    setPreviewData(response.data)
                }).catch((e) => {
                    console.log('fetch failed');
                });
    }
    const handleChange = (name, val) => {
        switch (name) {
            case "Network":
                setSpec({});
                setTemp({});
                setSelectedMediums([]);
                setSimulateData([]);
                setSelectedMetrics({})
                setNetworks(val);
                break;
            case "Content Type":
                setSpec({});
                setTemp({});
                setSelectedMediums([]);
                setSimulateData([]);
                setSelectedMetrics({})
                setContentTypes(val);
                break;
            case "Year":
                if (year !== val) {
                    setSpec({});
                    setTemp({});
                    setSelectedMediums([]);
                    setSimulateData([]);
                    setSelectedMetrics({})
                }
                setYear(val);
                break;
            case "Week":
                if (week != val) {
                    setSpec({});
                    setTemp({});
                    setSelectedMediums([]);
                    setSimulateData([]);
                    setSelectedMetrics({})
                }
                setWeek(val);
                break;
            default:
                break;
        }
    }
    const getDefaultValue = name => {
        switch (name) {
            case "Network":
                return networks;
            case "Content Type":
                return contentTypes;
            case "Year":
                return year;
            case "Week":
                return week;
            default:
                break;
        }
    }
    const onNext = e => {
        setSpec({
            year: year.year,
            weekId: week.weekId,
            // dates: period,
            networkDisplayName: networks.map(el => el.networkDisplayName).toString()
            // reportType: reportType === "Optimize" ? "optimization" : "simulation",
        })
        handleNext(activeTab)
    }
    const checkValues = _ => {
        if (networks.length === 0 || contentTypes.length === 0 || year === null || week === null)
            return true;
        return false
    }
    return (
        <>
            <div className={classes.rootContainer}>
                <div style={{ borderRight: "2px solid #ccc", marginLeft: "3.5rem" }}>
                    <div className={classes.titleCont}>
                        <div className={classes.titleHead}>Briefing</div>
                        {/* <div className={classes.titleText}>Some Text</div>//backgroundColor: "#f5f9fc" */}

                    </div>
                    <div className={classes.root}>
                        {
                            options.map(option => (
                                <Dropdown
                                    key={option.label}
                                    label={option.label}
                                    getLabel={option.getLabel}
                                    labelKey={option.labelKey}
                                    items={option.items}
                                    multiSelect={option.multiSelect}
                                    defaultValue={getDefaultValue(option.label)}
                                    onChange={e => handleChange(option.label, e)}
                                />
                            ))
                        }
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", padding: "0px 20px", marginLeft: 150 }}>
                        {/* <Button variant="contained" color="primary" classes={{ root: classes.button1, label: classes.buttonLabel }} onClick={e => gotoTab("optimizationPage")}>
                            Report Status
                        </Button> */}
                        <Button variant="contained" color="primary" classes={{ root: classes.button, label: classes.buttonLabel }} onClick={generatePreview}>
                            PREVIEW
                        </Button>
                        <Button variant="outlined" classes={{ root: classes.button, label: classes.buttonLabel }} disabled={checkValues()} onClick={onNext}>Next</Button>
                    </div>
                </div>
                <PreviewResults year={year} week={week} onClose={e => setShowPreview(false)} data={previewData} showPreview={showPreview} />

            </div>
        </>
    )
}

export default NewReportPrompt;